import { MarketplaceItem } from '../marketplace-item.model';
import { MarketplaceBasketCustomFieldModel } from './marketplace-basket-customfield.model';

export class MarketplaceBasketItem {
  constructor(
    public id: number,
    public rewardItemId: number,
    public gameNumber: number,
    public displayName: string,
    public pointsValue: number,
    public ecashValue: number,
    public merchantValue: number,
    public quantity: number,
    public attributeMappingId?: number,
    public maxQuantity?: number,
    public imageURL?: string,
    public customFields?: MarketplaceBasketCustomFieldModel[]
  ) {}

  static fromMarketplaceItem(
    marketplaceItem: MarketplaceItem,
    quantity: number = 1,
    attributeMappingId?: number,
    customFields?: MarketplaceBasketCustomFieldModel[]
  ): MarketplaceBasketItem {
    return new MarketplaceBasketItem(
      marketplaceItem.Id,
      marketplaceItem.ProductItemId,
      marketplaceItem.GameNumber,
      marketplaceItem.DisplayName,
      marketplaceItem.PointValue,
      marketplaceItem.EcashValue,
      marketplaceItem.MerchantValue,
      quantity,
      attributeMappingId,
      undefined,
      undefined,
      customFields
    );
  }
}
